import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
var INITIAL_WIDTH_MULTIPLIER = 0.95;
var DEFAULT_PDF_WIDTH = 932;
var MAX_SIZE_SCALE = 4;
export var usePDFSize = function usePDFSize(pdf, options) {
  var defaultWidth = computed(function () {
    return Math.floor(Math.min(options.width.value * INITIAL_WIDTH_MULTIPLIER, DEFAULT_PDF_WIDTH));
  });
  var maxWidth = computed(function () {
    return defaultWidth.value * MAX_SIZE_SCALE;
  });
  var width = ref(defaultWidth.value);
  var height = ref(DEFAULT_PDF_WIDTH);
  var scale = ref(1);
  watch(defaultWidth, function (val) {
    width.value = val;
    scale.value = 1;
    setPDFSizes();
  });
  var isZoomApplied = function isZoomApplied() {
    return width.value !== defaultWidth.value;
  };
  function setScale(_x) {
    return _setScale.apply(this, arguments);
  }
  function _setScale() {
    _setScale = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(zoomFactor) {
      var isResizeRequired, page, unscaledViewport, viewport;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isResizeRequired = width.value < maxWidth.value && zoomFactor > 1 || width.value > defaultWidth.value && zoomFactor < 1;
            if (!(!pdf.value || zoomFactor === 1 || !isResizeRequired)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return pdf.value.getPage(1);
          case 5:
            page = _context.sent;
            width.value *= zoomFactor;
            if (width.value > maxWidth.value) {
              width.value = maxWidth.value;
            } else if (width.value < defaultWidth.value) {
              width.value = defaultWidth.value;
            }
            unscaledViewport = page.getViewport({
              scale: 1
            });
            scale.value = width.value / unscaledViewport.width;
            viewport = page.getViewport({
              scale: scale.value
            });
            height.value = viewport.height;
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _setScale.apply(this, arguments);
  }
  function setPDFSizes() {
    return _setPDFSizes.apply(this, arguments);
  }
  function _setPDFSizes() {
    _setPDFSizes = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var page, unscaledViewport, viewport;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (pdf.value) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return pdf.value.getPage(1);
          case 4:
            page = _context2.sent;
            unscaledViewport = page.getViewport({
              scale: 1
            });
            scale.value = width.value / unscaledViewport.width;
            viewport = page.getViewport({
              scale: scale.value
            });
            height.value = Math.floor(viewport.height);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _setPDFSizes.apply(this, arguments);
  }
  return {
    width: width,
    height: height,
    scale: scale,
    setPDFSizes: setPDFSizes,
    setScale: setScale,
    isZoomApplied: isZoomApplied
  };
};